<template>
  <div v-if="!enable" class="page-loader">
    <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
  </div>
</template>

<script>
export default {
  props: {
    enable: Boolean
  }
}
</script>
